import {FormikHelpers} from 'formik';
import {RouteComponentProps} from 'react-router-dom';
import {notify} from '@gemcook/notification';

import paths from '@paths';
import utils from '@utils';
import constants from '@constants';

export const sendResetMail = async (
  value: any,
  formikAction: FormikHelpers<any>,
  props: RouteComponentProps
) => {
  try {
    await utils.amplify.resendConfirm(value.email);
    props.history.push(paths.signIn.main);
    notify('認証コードを送信しました。', 'success');
  } catch (error) {
    switch (error.message) {
      case 'Username/client id combination not found.':
        notify('入力されたメールアドレスは登録されていません。', 'error');
        break;
      case 'User is already confirmed.':
        notify(constants.ERRORS.EXISTED_CONFIRM_CODE, 'error');
        break;

      default:
        notify('認証コードの送信に失敗しました', 'error');
        break;
    }
  } finally {
    formikAction.setSubmitting(false);
  }
};
